import nsApi from '@netsapiens/netsapiens-js/dist/api';

export default ({
  domain,
  videoBridgeId,
}) => new Promise((resolve) => {
  nsApi.get({
    object: 'conference',
    action: 'read',
    aor: videoBridgeId,
    domain,
  }).then((res) => {
    if (res && res[0].aor === videoBridgeId) {
      resolve(videoBridgeId);
    } else {
      resolve(false);
    }
  }).catch(() => {
    resolve(false);
  });
});
